var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex items-center rounded-full flex-shrink-0",
      on: {
        click: function ($event) {
          return _vm.mouseover()
        },
        mouseleave: function ($event) {
          return _vm.mouseleaves()
        },
        dblclick: function ($event) {
          return _vm.click()
        },
      },
    },
    [
      _vm.avatar
        ? _c(
            "span",
            {
              staticClass:
                "flex-shrink-0 rounded-full bg-white flex items-center justify-center",
              class: _vm.outerContainerSize,
            },
            [
              _c("S3Image", {
                staticClass: "rounded-full",
                class: _vm.innerContainerSize,
                attrs: { s3FileKey: _vm.avatar },
              }),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "rounded-full bg-white flex items-center justify-center",
              class: _vm.outerContainerSize,
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "text-white font-bold rounded-full flex items-center justify-center text-xs",
                  class: _vm.innerContainerSize,
                  style: _vm.bgStyle,
                },
                [_vm._v(" " + _vm._s(_vm.initials) + " ")]
              ),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }